/* Royal Hair – product page logic (rh-main-product) */
(function () {
  /* 2026-10-22: run once per page. The file is included by several sections and the Theme Editor re-executes it on every section reload; listeners/observers must not accumulate. */
  if (window.__rhProductJs) return; window.__rhProductJs = true;
  var fmt = function (cents) {
    var n = cents / 100;
    var whole = Math.round(n * 100) % 100 === 0;
    return new Intl.NumberFormat('nb-NO', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(n).replace(/\u00a0/g, ' ') + ' kr';
  };

  function init(root) {
    if (root.dataset.rhpReady) return;
    root.dataset.rhpReady = '1';
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-rhp-variants]').textContent); } catch (e) {}
    var li = parseInt(root.dataset.lenIndex, 10);
    var ci = parseInt(root.dataset.colIndex, 10);
    var grams = parseInt(root.dataset.grams, 10) || 25;
    var form = root.querySelector('[data-rhp-form]');
    var idInput = root.querySelector('[data-rhp-id]');
    var qtyInput = root.querySelector('[data-rhp-qty]');
    var atc = root.querySelector('[data-rhp-atc]');
    var bonds = parseInt(root.dataset.bonds, 10) || 5;
    var pieces = parseInt(root.dataset.pieces, 10) || 10;
    var metaFmt = root.dataset.metaFormat || '[packs] packs · [grams] g · [bonds] bonds / [pieces] tape pieces';
    var meta = function (q) { return metaFmt.replace('[packs]', q).replace('[grams]', q * grams).replace('[bonds]', q * bonds).replace('[pieces]', q * pieces); };

    var lenInputs = root.querySelectorAll('[data-rhp-len]');
    var colInputs = root.querySelectorAll('[data-rhp-col]');
    var packInputs = root.querySelectorAll('[data-rhp-pack]');
    // Products whose only option is Length (e.g. Half Head): the length values are rendered as the single option selector, so there is no separate length input to match.
    if (!lenInputs.length) li = -1;

    function val(list) { for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i].value; return null; }

    function find(len, col) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if ((li < 0 || v.options[li] === len) && v.options[ci] === col) return v;
      }
      return null;
    }

    function current() { return find(val(lenInputs), val(colInputs)); }

    function qty() { var q = parseInt(qtyInput.value, 10); return isNaN(q) || q < 1 ? 1 : q; }

    function update(pushUrl) {
      _update(pushUrl);
      root.dispatchEvent(new CustomEvent('rh:updated'));
    }
    function _update(pushUrl) {
      var len = val(lenInputs), col = val(colInputs);
      var v = find(len, col);
      // availability states
      colInputs.forEach(function (inp) {
        var x = find(len, inp.value);
        inp.closest('label').classList.toggle('is-unavailable', !x || !x.available);
      });
      lenInputs.forEach(function (inp) {
        var x = find(inp.value, col);
        inp.closest('label').classList.toggle('is-unavailable', !x || !x.available);
      });
      var lenLabel = root.querySelector('[data-rhp-len-label]');
      if (lenLabel && len) lenLabel.textContent = len;
      var colLabel = root.querySelector('[data-rhp-col-label]');
      var checkedCol = root.querySelector('[data-rhp-col]:checked');
      if (colLabel && checkedCol) colLabel.textContent = checkedCol.dataset.label || checkedCol.value;
      // colour stage
      root.querySelectorAll('[data-rhp-stage]').forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.rhpStage === col);
      });
      if (!v) {
        atc.disabled = true; atc.textContent = atc.dataset.soldout; return;
      }
      idInput.value = v.id;
      var unit = root.querySelector('[data-rhp-unit-price]');
      if (unit) unit.textContent = fmt(v.price);
      root.querySelectorAll('[data-rhp-pack-price]').forEach(function (el) {
        el.textContent = fmt(v.price * parseInt(el.dataset.rhpPackPrice, 10));
      });
      var q = qty();
      var total = root.querySelector('[data-rhp-total]');
      if (total) total.textContent = fmt(v.price * q);
      var metaEl = root.querySelector('[data-rhp-total-meta]');
      if (metaEl) metaEl.textContent = meta(q);
      atc.disabled = !v.available;
      atc.textContent = v.available ? atc.dataset.label : atc.dataset.soldout;
      if (pushUrl && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    function syncPacks() {
      var q = qty();
      packInputs.forEach(function (p) { p.checked = parseInt(p.value, 10) === q; });
    }

    lenInputs.forEach(function (i) { i.addEventListener('change', function () { update(true); }); });
    colInputs.forEach(function (i) {
      i.addEventListener('change', function () {
        update(true);
        syncGalleryColour(root, i.value);
        // Keep the large colour preview in view
        var stage = root.querySelector('[data-rhp-preview]');
        if (stage && stage.offsetParent !== null) {
          var r = stage.getBoundingClientRect();
          if (r.top < 60 || r.top > window.innerHeight - 120) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
          stage.classList.remove('is-swap'); void stage.offsetWidth; stage.classList.add('is-swap');
        }
      });
    });
    packInputs.forEach(function (p) {
      p.addEventListener('change', function () { qtyInput.value = p.value; update(false); });
    });
    qtyInput.addEventListener('input', function () { syncPacks(); update(false); });
    root.querySelectorAll('[data-rhp-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = Math.max(1, Math.min(20, qty() + parseInt(b.dataset.rhpStep, 10)));
        qtyInput.value = q; syncPacks(); update(false);
      });
    });

    var anchor = root.querySelector('[data-rhp-anchor]');
    if (anchor) anchor.addEventListener('click', function (e) {
      var t = document.querySelector('[id$="__' + anchor.dataset.rhpAnchor + '"]') || document.getElementById(anchor.dataset.rhpAnchor);
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });

    // Purchase mode
    root.querySelectorAll('[data-rhp-mode]').forEach(function (m) {
      m.addEventListener('change', function () {
        root.querySelectorAll('[data-rhp-panel]').forEach(function (p) { p.hidden = p.dataset.rhpPanel !== m.value; });
      });
    });

    // Salon booking + deposit
    var rhb = root.querySelector('[data-rhb]');
    if (rhb) {
      var salons = rhb.querySelectorAll('[data-rhb-salon]');
      var step2 = rhb.querySelector('[data-rhb-step="2"]');
      var step3 = rhb.querySelector('[data-rhb-step="3"]');
      var frame = rhb.querySelector('[data-rhb-frame]');
      var newtab = rhb.querySelector('[data-rhb-newtab]');
      var dateIn = rhb.querySelector('[data-rhb-date]');
      var timeIn = rhb.querySelector('[data-rhb-time]');
      var cta = rhb.querySelector('[data-rhb-cta]');
      var bErr = rhb.querySelector('[data-rhb-error]');
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var now = new Date();
      dateIn.min = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
      var lang = (document.documentElement.lang || 'en').slice(0, 2);
      var salonVal = function () { return val(salons); };
      var hairText = function () {
        var v = current();
        var cc = root.querySelector('[data-rhp-col]:checked');
        var parts = [root.dataset.productTitle || '', val(lenInputs), cc ? (cc.dataset.label || cc.value) : '', meta(qty())];
        return parts.filter(Boolean).join(' · ');
      };
      var whenText = function () {
        if (!dateIn.value || !timeIn.value) return '';
        var d = new Date(dateIn.value + 'T' + timeIn.value);
        try {
          return d.toLocaleDateString(lang === 'en' ? 'en-GB' : 'nb-NO', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) + ' · ' + timeIn.value;
        } catch (e) { return dateIn.value + ' ' + timeIn.value; }
      };
      var refresh = function () {
        var ok = salonVal() && dateIn.value && timeIn.value;
        step3.hidden = !ok;
        if (!ok) return;
        rhb.querySelector('[data-rhb-sum-salon]').textContent = salonVal();
        rhb.querySelector('[data-rhb-sum-when]').textContent = whenText();
        rhb.querySelector('[data-rhb-sum-hair]').textContent = hairText();
      };
      salons.forEach(function (sx) {
        sx.addEventListener('change', function () {
          step2.hidden = false;
          var url = sx.dataset.url;
          newtab.href = url;
          frame.innerHTML = '';
          if (url) {
            var f = document.createElement('iframe');
            f.src = url; f.title = sx.value;
            f.setAttribute('allow', 'payment');
            frame.appendChild(f);
          }
          refresh();
        });
      });
      var when = rhb.querySelector('.rhb__when');
      [dateIn, timeIn].forEach(function (x) {
        x.addEventListener('change', function () { refresh(); if (dateIn.value && timeIn.value && when) when.classList.remove('is-return'); });
        x.addEventListener('input', refresh);
      });
      // Timma opens the booking steps in a new tab. When the customer comes back, guide her to the time fields.
      var away = false;
      var markAway = function () { if (!step2.hidden && !(dateIn.value && timeIn.value)) away = true; };
      newtab.addEventListener('click', markAway);
      window.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement && document.activeElement.tagName === 'IFRAME') markAway(); }, 0); });
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') { markAway(); return; }
        if (!away) return;
        away = false;
        if (dateIn.value && timeIn.value) return;
        when.classList.add('is-return');
        when.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      root.addEventListener('rh:updated', refresh);
      cta.addEventListener('click', function () {
        var id = parseInt(rhb.dataset.depositVariant, 10);
        if (!id) return;
        bErr.hidden = true;
        var props = {};
        props[rhb.dataset.propSalon || 'Salon'] = salonVal();
        props[rhb.dataset.propAppointment || 'Appointment'] = whenText();
        props[rhb.dataset.propHair || 'Reserved hair'] = hairText();
        var v = current();
        if (v) props._hair_variant_id = String(v.id);
        props._hair_packs = String(qty());
        cta.classList.add('is-loading'); cta.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props }] })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw res.j;
            if (window.RHConsent && window.RHConsent.toCheckout) window.RHConsent.toCheckout();
            else window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
          })
          .catch(function (j) {
            cta.classList.remove('is-loading'); cta.disabled = false;
            bErr.textContent = (j && (j.description || j.message)) || root.dataset.errorText; bErr.hidden = false;
          });
      });
    }

    // "See all colours" link opens the colour guide row
    root.querySelectorAll('a[href="#rh-colour-guide"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var g = document.getElementById('rh-colour-guide');
        if (!g) return;
        e.preventDefault();
        var d = g.querySelector('details'); if (d) d.open = true;
        g.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Pick colour from colour guide
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rhp-pick]');
      if (!btn) return;
      var value = btn.dataset.rhpPick;
      var shade = function (v) { v = String(v || '').toLowerCase(); if (v.indexOf('ombre') > -1) return 'ombre'; var m = v.match(/#\s*([0-9a-z]+)/); return m ? m[1] : v; };
      var inp = Array.prototype.find.call(colInputs, function (i) { return i.value === value; }) ||
        Array.prototype.find.call(colInputs, function (i) { return shade(i.value) === shade(value); });
      if (!inp) return;
      inp.checked = true; update(true); syncGalleryColour(root, inp.value);
      var pv = root.querySelector('[data-rhp-preview]');
      if (!pv || pv.offsetParent === null) pv = (root.closest('.shopify-section') || document).querySelector('[data-rhp-gallery]') || root;
      pv.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Line item properties from the form (e.g. purchase consent)
    function formProps() {
      var out = {};
      new FormData(form).forEach(function (v, k) {
        var m = /^properties\[(.+)\]$/.exec(k);
        if (m && typeof v === 'string') out[m[1]] = v;
      });
      return out;
    }

    // Add to cart (AJAX with graceful fallback)
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var err = root.querySelector('[data-rhp-error]');
      var added = root.querySelector('[data-rhp-added]');
      err.hidden = true; added.hidden = true;
      atc.classList.add('is-loading');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: qty(), properties: formProps() }], sections: 'cart-icon-bubble' })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          atc.classList.remove('is-loading');
          if (!res.ok) { err.textContent = res.j.description || res.j.message || root.dataset.errorText; err.hidden = false; return; }
          added.hidden = false;
          var html = res.j.sections && res.j.sections['cart-icon-bubble'];
          var bubble = document.getElementById('cart-icon-bubble');
          if (html && bubble) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
          document.dispatchEvent(new CustomEvent('rh:cart-added', { detail: res.j }));
        })
        .catch(function () { atc.classList.remove('is-loading'); form.submit(); });
    });

    // Prefill from links such as Hair Match: ?packs=6&mode=salon
    try {
      var qp = new URLSearchParams(window.location.search);
      var qpPacks = parseInt(qp.get('packs'), 10);
      if (qpPacks >= 1 && qpPacks <= 20) { qtyInput.value = qpPacks; syncPacks(); }
      var qpMode = qp.get('mode');
      if (qpMode) {
        var mEl = root.querySelector('[data-rhp-mode][value="' + qpMode.replace(/[^a-z]/g, '') + '"]');
        if (mEl) { mEl.checked = true; mEl.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    } catch (e) {}

    // Preload the other colour previews so switching is instant
    // 2026-10-23 perf: warm only the colour card the customer is about to pick (hover/touch/focus on a swatch),
    // instead of downloading every colour card (~3 MB on Keratin) after page load.
    var warm = function (e) {
      var inp = e.target && e.target.closest && e.target.closest('.rhp__swatch');
      inp = inp && inp.querySelector('[data-rhp-col]');
      if (!inp) return;
      var st = rhpStageFor(root, inp.value), im = st && st.querySelector('img');
      if (im && im.loading !== 'eager') im.loading = 'eager';
    };
    root.addEventListener('pointerover', warm, { passive: true });
    root.addEventListener('touchstart', warm, { passive: true });
    root.addEventListener('focusin', warm);

    update(false);
  }

  // Product gallery: one image at a time, arrows + dots (swipe stays native)
  function stickyTop(g) {
    // Keep the sticky gallery clear of the fixed site header
    var hdr = document.querySelector('.section-header');
    var setTop = function () {
      var b = 0;
      var hb = (document.querySelector('.section-header .header-wrapper') || document.querySelector('.section-header'));
      if (hb) { var r = hb.getBoundingClientRect(); b = Math.max(0, Math.round(r.bottom)); }
      g.style.setProperty('--rhp-top', (b + 20) + 'px');
    };
    setTop();
    window.addEventListener('scroll', setTop, { passive: true });
    window.addEventListener('resize', setTop);
    if (hdr && window.MutationObserver) new MutationObserver(function () { requestAnimationFrame(setTop); setTimeout(setTop, 320); }).observe(hdr, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  /* Mobile only: the selected colour's colour card becomes gallery image 3 (hidden on desktop by CSS). */
  var RHP_DESK = '(min-width: 990px)';
  function rhpStageFor(root, col) {
    var st = root.querySelectorAll('[data-rhp-stage]'), hit = null, sh = rhpShade(col);
    for (var i = 0; i < st.length; i++) { if (st[i].getAttribute('data-rhp-stage') === col) { hit = st[i]; break; } }
    if (!hit) { for (var j = 0; j < st.length; j++) { if (rhpShade(st[j].getAttribute('data-rhp-stage')) === sh) { hit = st[j]; break; } } }
    return hit;
  }
  function rhpSetCard(g, root, col) {
    var card = g.querySelector('[data-rhp-card-slide]');
    if (!card || !root) return null;
    var stage = rhpStageFor(root, col);
    var src = stage && stage.querySelector('img');
    var im = card.querySelector('img');
    if (src && im) {
      var ss = src.getAttribute('srcset'), s = src.getAttribute('src');
      if (ss && im.getAttribute('srcset') !== ss) im.setAttribute('srcset', ss);
      if (s && im.getAttribute('src') !== s) im.setAttribute('src', s);
      im.alt = src.alt || col;
      card.setAttribute('data-rhp-card-colour', col);
    }
    return card;
  }
  function rhpBuildCard(g) {
    var scope = g.closest('.shopify-section') || document;
    var root = scope.querySelector('[data-rhp]');
    var track = g.querySelector('[data-rhp-slides]');
    if (!root || !track || !root.hasAttribute('data-rhp-card') || g.querySelector('[data-rhp-card-slide]')) return;
    if (!root.querySelector('[data-rhp-stage] img')) return; /* no colour-card asset: keep the large preview */
    var fig = document.createElement('figure');
    fig.className = 'rhp__slide rhp__slide--card';
    fig.setAttribute('data-rhp-card-slide', '');
    var im = document.createElement('img');
    im.loading = 'eager'; im.decoding = 'async';
    im.setAttribute('sizes', '100vw');
    fig.appendChild(im);
    var base = Array.prototype.filter.call(track.children, function (el) { return el.classList.contains('rhp__slide'); });
    var after = base[1] || base[base.length - 1];
    if (after && after.nextSibling) track.insertBefore(fig, after.nextSibling); else track.appendChild(fig);
    var checked = root.querySelector('[data-rhp-col]:checked');
    var active = root.querySelector('.rhp__colour-stage.is-active');
    rhpSetCard(g, root, checked ? checked.value : (active ? active.getAttribute('data-rhp-stage') : ''));
    root.classList.add('rhp--card');
  }

  function initGallery(g) {
    if (g.__rhpGal) return; g.__rhpGal = true;
    stickyTop(g);
    var track = g.querySelector('[data-rhp-slides]');
    if (!track) return;
    rhpBuildCard(g);
    var visible = function () {
      return Array.prototype.filter.call(track.children, function (el) {
        return el.classList.contains('rhp__slide') && getComputedStyle(el).display !== 'none';
      });
    };
    var slides = visible();
    if (slides.length < 2) return;
    g.__rhpSlides = slides;
    var prev = g.querySelector('[data-rhp-prev]'), next = g.querySelector('[data-rhp-next]'), dotsEl = g.querySelector('[data-rhp-dots]');
    var dots = [];
    var active = 0;
    var go = function (i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      active = i; render();
      if (instant) {
        /* Colour jumps: land exactly on the slide (no smooth scroll that a page scroll could interrupt). */
        var xi = slides[i].offsetLeft - track.offsetLeft;
        track.style.scrollBehavior = 'auto'; track.scrollLeft = xi;
        clearTimeout(go.t);
        go.t = setTimeout(function () { if (active === i && Math.abs(track.scrollLeft - xi) > 2) track.scrollLeft = xi; track.style.scrollBehavior = ''; }, 400);
        return;
      }
      // Update the UI first, then scroll, so no style change interrupts the smooth scroll
      var x = slides[i].offsetLeft - track.offsetLeft;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: x, behavior: reduce ? 'auto' : 'smooth' });
      // Safety net: if the smooth scroll is interrupted, land exactly on the slide
      clearTimeout(go.t);
      go.t = setTimeout(function () { if (Math.abs(track.scrollLeft - x) > 2 && active === i) track.scrollLeft = x; }, 700);
    };
    var current = function () {
      var x = track.scrollLeft, best = 0, d = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var dd = Math.abs(slides[i].offsetLeft - track.offsetLeft - x);
        if (dd < d) { d = dd; best = i; }
      }
      return best;
    };
    var render = function () {
      dots.forEach(function (b, i) { b.classList.toggle('is-active', i === active); b.setAttribute('aria-current', i === active ? 'true' : 'false'); });
      prev.disabled = active === 0; next.disabled = active === slides.length - 1;
    };
    var buildDots = function () {
      dotsEl.innerHTML = ''; dots = [];
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'rhp__dot';
        b.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
        b.addEventListener('click', function () { go(i); });
        dotsEl.appendChild(b); dots.push(b);
      });
    };
    buildDots();
    var sync = function () {
      var c = current();
      if (c !== active) { active = c; render(); }
    };
    prev.hidden = false; next.hidden = false;
    prev.addEventListener('click', function () { go(active - 1); });
    next.addEventListener('click', function () { go(active + 1); });
    var t;
    if ('onscrollend' in window) track.addEventListener('scrollend', sync);
    else track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 180); }, { passive: true });
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(active - 1); } else if (e.key === 'ArrowRight') { go(active + 1); }
    });
    /* Desktop <-> mobile: the colour-card slide only exists on mobile, so rebuild the slide list and dots. */
    if (window.matchMedia) {
      var mq = window.matchMedia(RHP_DESK);
      var onBp = function () {
        var cur = slides[active];
        slides = visible(); g.__rhpSlides = slides;
        var ni = slides.indexOf(cur); active = ni < 0 ? 0 : ni;
        buildDots(); render();
        track.style.scrollBehavior = 'auto'; track.scrollLeft = slides[active].offsetLeft - track.offsetLeft; track.style.scrollBehavior = '';
      };
      if (mq.addEventListener) mq.addEventListener('change', onBp); else if (mq.addListener) mq.addListener(onBp);
    }
    render();
    g.__rhpGo = go;
  }

  /* Selected colour -> matching large image in the gallery (curated colour slide first, then the variant's own colour photo). */
  function rhpShade(v) { v = String(v || '').toLowerCase(); if (v.indexOf('ombre') > -1) return 'ombre'; var m = v.match(/#\s*([0-9a-z]+)/); return m ? m[1] : v; }
  function syncGalleryColour(root, col) {
    /* The selected colour is shown by the authentic colour card only.
       Mobile: gallery image 3 (the colour card slide) follows the colour and is brought into view.
       Desktop: the large colour card beside the product information updates; the gallery does not move. */
    var scope = root.closest('.shopify-section') || document;
    var g = scope.querySelector('[data-rhp-gallery]');
    if (!g || !col) return;
    var track = g.querySelector('[data-rhp-slides]');
    if (!track) return;
    var slides = g.__rhpSlides || Array.prototype.filter.call(track.children, function (el) { return el.classList.contains('rhp__slide'); });
    var card = rhpSetCard(g, root, col);
    if (card && slides.indexOf(card) > -1 && g.__rhpGo) g.__rhpGo(slides.indexOf(card), true);
  }

  function boot() { document.querySelectorAll('[data-rhp]').forEach(init); document.querySelectorAll('[data-rhp-gallery]').forEach(initGallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-rhp]'); if (el) init(el);
    var gl = e.target.querySelector('[data-rhp-gallery]'); if (gl) initGallery(gl);
  });
  /* Theme Editor: with the select tool on, a click on a swatch / package selects its block instead of
     reaching the input. Apply the choice on block select so the preview behaves like the storefront. */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target; if (!el || !el.closest || !el.closest('[data-rhp]')) return;
    var inp = el.matches('input[type=radio]') ? el : el.querySelector('input[type=radio]');
    if (!inp || inp.disabled || inp.checked) return;
    inp.checked = true;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
